export enum MetricActionType {
  Update = 'update',
  Ignore = 'ignore',
}
